<template>
	<v-touch v-if="game.active_card" class="card-info" @tap="close()">
		<div class="card-info-content">
			<p class="name">{{ game.active_card[lang].name }}</p>
			<card :card="game.active_card" />
			<p class="text">{{ game.active_card[lang].description }}</p>
		</div>
	</v-touch>
</template>

<script>
import { mapGetters } from 'vuex'
import Card from './Card'

export default {
	name: 'CardInfo',
	data () {
		return {
			
		}
	},
	computed: Object.assign(mapGetters([ 'game', 'lang', 'user' ]), {
		
	}),
	methods: {
		close: function() {
			if (this.user.first_times.tuto) {
				if (this.game.tuto_step === 10) {
					this.$store.commit('SET_ACTIVE_CARD', { card: false })
					this.$store.dispatch('next_tuto')
				}
			}
			else {
				this.$store.commit('SET_ACTIVE_CARD', { card: false })
			}
		}
	},
	components: { Card }
}
</script>

<style lang="stylus">
@import '../../assets/css/app'

.card-info
	position absolute
	left 0
	top 0
	right 0
	bottom 0
	background alpha(#000, 80%)
	z-index 2
	.card-info-content
		height 100%
		width 100%
		display flex
		align-items center
		align-content center
		justify-content center
		flex-direction column
		color #fff
		.name
			padding 16px 32px
			font-size 32px
			line-height 36px
			text-align center
		.card
			transform scale(2)
			margin 48px 0
		.text
			padding 16px 60px
			text-align center
			font-size 16px
			line-height 20px
	
</style>



// WEBPACK FOOTER //
// src/components/game/CardInfo.vue